import LogoutIcon from '@mui/icons-material/Logout';
import ListIcon from '@mui/icons-material/List';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
sessionStorage.setItem("active", '');
// Nav Data

export const userMenu =
    [
        {
            id: 0,
            icon: <PersonAddAltRoundedIcon />,
            text: "Create User",
            link: "/createuser",
        },
        {
            id: 1,
            icon: <ListIcon />,
            text: "List of User",
            link: "/userdashboard",
        }
    ]

